const getDateFilterValue = (series) => {
    return {
        range: series.find((s) => !s.isCompare)?.range,
        compareRange: series.find((s) => s.isCompare)?.range,
    };
};
exports.getDateFilterValue = getDateFilterValue;
